/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

/**
 * Value paths that identify the language column of a `list:language`
 * attribute. Schemas use either name (e.g. `machinery-1.2.0` uses
 * `languageCode`, older test schemas use `language`).
 */
export const LANGUAGE_COLUMN_VALUE_PATHS: readonly string[] = [
  'languageCode',
  'language',
];

/**
 * Whether a sub-attribute value path is the language column of a
 * `list:language` attribute.
 *
 * @param valuePath - The sub-attribute's `valuePath`.
 * @returns True for `languageCode` and `language`.
 */
export function isLanguageColumn(valuePath: string | undefined): boolean {
  return !!valuePath && LANGUAGE_COLUMN_VALUE_PATHS.includes(valuePath);
}

/**
 * Finds the language column among the sub-attributes of a `list:language`
 * attribute, wherever it is declared.
 *
 * @param attributes - The `list:language` attribute's sub-attributes.
 * @returns The language sub-attribute, or `undefined` when there is none.
 */
export function findLanguageColumn<T extends {valuePath: string}>(
  attributes: T[] | undefined,
): T | undefined {
  return attributes?.find((attribute) => isLanguageColumn(attribute.valuePath));
}
